module.exports = __webpack_public_path__ + "static/media/id.ff1f2921.svg";